var path = 'metadataCompare/resultsView/results.tpl.html';
var html = "<react-component name=\"metadata-compare-info\" />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;